import React from 'react';

interface Props {
  stockAmount: number;
  hasDigital?: boolean;
}

const ProductDetailTrust: React.FC<Props> = ({ stockAmount, hasDigital }) => {
  // -1 = neomezený sklad (digitální produkt), 0 = vyprodáno
  const inStock = stockAmount !== 0;
  return (
    <ul className="pd-trust">
      <li className={`pd-trust__item ${inStock ? 'pd-trust__item--ok' : 'pd-trust__item--out'}`}>
        <span className="pd-trust__icon" aria-hidden="true">{inStock ? '✓' : '×'}</span>
        <span className="pd-trust__label">
          {inStock
            ? (stockAmount > 0 && stockAmount < 5 ? `Skladem (posledních ${stockAmount} ks)` : 'Skladem')
            : 'Momentálně nedostupné'}
        </span>
      </li>
      <li className="pd-trust__item pd-trust__item--ok">
        <span className="pd-trust__icon" aria-hidden="true">✓</span>
        <span className="pd-trust__label">Doručení 1–3 pracovní dny</span>
      </li>
      {hasDigital && (
        <li className="pd-trust__item pd-trust__item--ok">
          <span className="pd-trust__icon" aria-hidden="true">✓</span>
          <span className="pd-trust__label">PDF verzi obdržíte ihned po platbě</span>
        </li>
      )}
      <li className="pd-trust__item pd-trust__item--ok">
        <span className="pd-trust__icon" aria-hidden="true">✓</span>
        <span className="pd-trust__label">Vrácení do 14 dnů</span>
      </li>
      <li className="pd-trust__item pd-trust__item--ok">
        <span className="pd-trust__icon" aria-hidden="true">✓</span>
        <span className="pd-trust__label">Bezpečná platba</span>
      </li>
    </ul>
  );
};

export default ProductDetailTrust;
